import { OTHER_DETAILS } from './expressLetter';

export const AIRCRAFT_STATION_INFORMATION = 'aircraft-station-info';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';
export const HF_TRANSCEIVER = 'hf-transceiver';
export const VHF_TRANSCEIVER = 'vhf-transceiver';
export const ADF_TRANSCEIVER = 'adf-transceiver';
export const EMERGENCY_RADIO_BEACON = 'emergency-radio-beacon';
export const MARKER_RECEIVER = 'marker-receiver';
export const VHF_NAV_TRANSCEIVER = 'vhf-nav-transceiver';
export const GLIDE_SLOPE_TRANSCEIVER = 'glide-slope-transceiver';
export const DME_TRANSMITTER = 'dme-transmitter';
export const DME_RECEIVER = 'dme-receiver';
export const ATC_TRANSMITTER = 'atc-transmitter';
export const ATC_RECEIVER = 'atc-receiver';
export const WEATHER_C_BAND = 'weather-c-band';
export const WEATHER_X_BAND = 'weather-x-band';
export const WEATHER_ALTIMETER_TRANSCEIVER = 'weather-altimeter';
export const DOPPLER_NAV_TRANSCEIVER = 'doppler-nav-transceiver';
export const RADIO_ALTIMETER_TRANSCEIVER = 'radio-altimeter-transceiver';
export const GPS_RECEIVER = 'gps-receiver';
export const OTHERS = 'others';

export const AIRCRAFTLICENCE = [
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'usedOfSystem',
                label: 'Proposed Use of System',
                type: 'text'
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text'
            }
        ]
    },
    {
        sectionID: AIRCRAFT_STATION_INFORMATION,
        sectionName: 'Aircraft Station Information',
        fieldList: [
            {
                id: 'callSign',
                label: 'Call Sign',
                type: 'text'
            },
            {
                id: 'aircraftCategory',
                label: 'Aircraft Category',
                type: 'text'
            },
            {
                id: 'aircraftRegistrationNo',
                label: 'Aircraft Registration No.',
                type: 'text'
            },
            {
                id: 'aircraftType',
                label: 'Aircraft Type',
                type: 'text'
            },
            {
                id: 'aircraftSerialNo',
                label: 'Aircraft Serial No.',
                type: 'text'
            },
            {
                id: 'aircraftSelectiveCallNo',
                label: 'Aircraft Selective Call No.',
                type: 'text'
            }
        ]
    },
    {
        sectionID: OTHERS,
        sectionName: 'Equipment Information',
        fieldList: [
            {
                id: 'other',
                label: ' ',
                type: 'table',
                subFields: [
                    {
                        id: 'typeEquipment',
                        header: 'Type of equipment',
                        type: 'text'
                    },
                    {
                        id: 'manufacturer',
                        header: 'Manufacturer',
                        type: 'text'
                    },
                    {
                        id: 'model',
                        header: 'Model',
                        type: 'text'
                    },
                    {
                        id: 'frequencyFrom',
                        header: 'Frequency From (MHz)',
                        type: 'text'
                    },
                    {
                        id: 'frequencyTo',
                        header: 'Frequency To (MHz)',
                        type: 'text'
                    }
                ],
                span: 12
            }
        ]
    }
];
